var map = {
	"./Abhinav/images/SideBarLastIcon.svg": [
		25916,
		5916
	],
	"./Agrasen/images/SideBarLastIcon.svg": [
		63816,
		3816
	],
	"./Bhagini/images/SideBarLastIcon.svg": [
		91201,
		1201
	],
	"./DMKJ/images/SideBarLastIcon.svg": [
		26207,
		6207
	],
	"./Deogiri/images/SideBarLastIcon.svg": [
		9012,
		9012
	],
	"./JCOM/images/SideBarLastIcon.svg": [
		8758,
		8758
	],
	"./MOGAVEERA/images/SideBarLastIcon.svg": [
		78740,
		8740
	],
	"./Mahesh/images/SideBarLastIcon.svg": [
		3839,
		3839
	],
	"./NCBM/images/SideBarLastIcon.svg": [
		79935,
		9935
	],
	"./Noble/images/SideBarLastIcon.svg": [
		30585,
		585
	],
	"./RSSB/images/SideBarLastIcon.svg": [
		25467,
		5467
	],
	"./Samta/images/SideBarLastIcon.svg": [
		83989,
		3989
	],
	"./Satara/images/SideBarLastIcon.svg": [
		10491,
		491
	],
	"./Sawji/images/SideBarLastIcon.svg": [
		425,
		425
	],
	"./Shriraksh/images/SideBarLastIcon.svg": [
		12706,
		2706
	],
	"./Suvarna/images/SideBarLastIcon.svg": [
		43561,
		3561
	],
	"./Ucob/images/SideBarLastIcon.svg": [
		62588,
		2588
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95343;
module.exports = webpackAsyncContext;